import { render, staticRenderFns } from "./pleaseWait.vue?vue&type=template&id=4018b6f6"
import script from "./pleaseWait.vue?vue&type=script&lang=js"
export * from "./pleaseWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports